import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { apiService } from './api.service';
import { Rail } from '../types';

class RailsService {
  async getAllRails(status: string = STATUS_FILTER_VALUES.ALL): Promise<Rail[]> {
    try {
      const params = { [QUERY_PARAMS.STATUS]: status };
      return await apiService.get<Rail[]>(CR_API_ENDPOINTS.RAILS, params);
    } catch (error) {
      throw new Error(`Failed to fetch rails: ${error}`);
    }
  }

  async getActiveRails(): Promise<Rail[]> {
    try {
      const params = { [QUERY_PARAMS.STATUS]: STATUS_FILTER_VALUES.ACTIVE };
      return await apiService.get<Rail[]>(CR_API_ENDPOINTS.RAILS, params);
    } catch (error) {
      throw new Error(`Failed to fetch active rails: ${error}`);
    }
  }

  async getRailById(id: string): Promise<Rail> {
    try {
      return await apiService.get<Rail>(`${CR_API_ENDPOINTS.RAILS}/${id}`);
    } catch (error) {
      throw new Error(`Failed to fetch rail: ${error}`);
    }
  }

  async createRail(railData: {
    name: string;
    domesticStatus: string;
    length?: number;
    attachmentIds?: string[];
  }): Promise<Rail> {
    try {
      return await apiService.post<Rail>(CR_API_ENDPOINTS.RAILS, railData);
    } catch (error) {
      throw new Error(`Failed to create rail: ${error}`);
    }
  }
}

export const railsService = new RailsService();